import MenuItem, { MenuItemType } from '../../common/components/MenuItem'

export interface MenuProps {
  activeHeader?: 'shipmentTracking' | 'aboutShipment' | 'shipmentEvents' | 'none' | 'hidden'
}

function Menu({ activeHeader = 'hidden' }: MenuProps) {
  if (activeHeader === 'hidden') {
    return null
  }

  return (
    <ul className="flex items-center ">
      <ListItem isActive={activeHeader === 'shipmentTracking'} menuItemType={'shipmentTracking'} />
      <ListItem isActive={activeHeader === 'aboutShipment'} menuItemType={'aboutShipment'} />
      <ListItem isActive={activeHeader === 'shipmentEvents'} menuItemType={'shipmentEvents'} />
    </ul>
  )
}

const ListItem = (props: { isActive: boolean; menuItemType: MenuItemType }) => (
  <li className="my-3 px-6 border-r border-solid border-gray-300 last:border-0">
    <MenuItem {...props} />
  </li>
)

export default Menu
